module.exports = __webpack_public_path__ + "static/img/e407a9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dy/lpic.png
// module id = 635
// module chunks = 2